import * as Yup from 'yup';
import { WorkOrderState } from '@models';

export function useValidationSchema() {
  return Yup.object<WorkOrderState>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
  }) as Yup.Schema<WorkOrderState>;
}
